import { Injectable } from '@angular/core';

import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiRequestService } from './api-request.service';

@Injectable()
export class UsuarioService {

  constructor (
    private apiRequestService: ApiRequestService
  ) { }

  getDadosUsuario (url: string) {
    return this.apiRequestService.get (url);
  }

}
